var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m40.754 482h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.754 482h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.754 482h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.754 417h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.754 417h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.754 417h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.75 338.5h-17.5v-161c0-97.874-79.626-177.5-177.5-177.5s-177.5 79.626-177.5 177.5v41.599c-24.807 14.184-42.71 39.113-47.325 68.401h-31.175v47.5c0 26.191 21.309 47.5 47.5 47.5h157c26.191 0 47.5-21.309 47.5-47.5v-47.5h-31.175c-4.615-29.288-22.519-54.217-47.325-68.401v-41.599c0-45.491 37.009-82.5 82.5-82.5 45.49 0 82.5 37.009 82.5 82.5v334.5h95v-78.5h17.5c26.191 0 47.5-21.309 47.5-47.5s-21.309-47.5-47.5-47.5zm-229-3.5c0 9.649-7.851 17.5-17.5 17.5h-157c-9.649 0-17.5-7.851-17.5-17.5v-17.5h192zm-160.26-47.5c6.812-29.187 33.028-51 64.26-51s57.448 21.813 64.26 51zm341.76 194.5h-35v-304.5c0-62.033-50.468-112.5-112.5-112.5-62.033 0-112.5 50.467-112.5 112.5v30.604c-5.676-1.05-11.524-1.604-17.5-1.604s-11.824.554-17.5 1.604v-30.604c0-81.332 66.168-147.5 147.5-147.5s147.5 66.168 147.5 147.5zm47.5-78.5h-17.5v-35h17.5c9.649 0 17.5 7.851 17.5 17.5s-7.851 17.5-17.5 17.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/shower.08edb316a650937e94ad3942838f80bc.svg";
export { ForwardRef as ReactComponent };